export const locale = {
    lang: 'pl',
    data: {
        "Additional informations": "Dodatkowe informacje",
        "Add to bill": "Dodaj do rachunku",
        "Price gross": "Cena brutto",
        "VAT rate": "Stawka VAT",
        "Included services": "Usługi",
        "Select customer": "Wybierz klienta",
        "Create invoice": "Utwórz fakturę",
        "Street": "Ulica",
        "Post code": "Kod pocztowy",
        "Country": "Kraj",
        "City": "Miasto",
        "Worker": "Pracownik",
        "Cancel": "Anuluj",
        "Update bill": "Aktualizuj rachunek",
        "Poland": "Polska",
        "Confirm receipt print": "Potwierdź wydruk paragonu",
        "Confirm invoice print": "Potwierdź wydruk faktury",
        "Confirm": "Potwierdź",
        "PRODUCT": "PRODUKT",
        "PRICE": "CENA",
        "QUANTITY": "ILOŚĆ",
        "TOTAL": "RAZEM",
        "for customer": "dla klienta",
        "First payment method": "Pierwsza metoda płatności",
        "Second payment method": "Druga metoda płatności",
        "Value": "Wartość",
        "Sum of first and second value has to be equal to": "Suma pierwszej i drugiej wartości musi być równa",
        "true": "Tak",
        "false": "Nie",
        "Name": "Nazwa",
        "Close": "Zamknij",
        "Products": "Produkty",
        "Lines": "Linie",
        "Can connect": "Może się łączyć",
        "Available only first time": "Dostępny tylko pierwszego razu",
        "Loading data": "Wczytywanie danych",
        "Products/Vouchers/Lines": "Produkty/Karnety/Linie",
        "Used discounts": "Użyte rabaty",
        "REGULAR PRICE": "CENA REGULARNA",
        "Active discounts not found.": "Aktywne rabaty nie zostały znalezione.",
        "It looks like fiscal printer is inactive longer than 30s. Check printer and printer application.": "Wygląda na to, że drukarka fiskalna jest nieaktywna dłużej niż 30s. Zweryfikuj proszę czy drukarka fiskalna oraz aplikacja nią sterująca są aktywne.",
        "Fiscal printer is inactive!": "Drukarka fiskalna jest nieaktywna!",
        "VAT ID is required to create invoice": "Numer NIP jest wymagany do utworzenia faktury"
    }
};
